<div class="campaign" *ngIf="campaign">
	<div class="name-activate">
		<div class="name">
			<h2>Campaign Name</h2>
			<input pInputText [(ngModel)]="campaign.campaignName" (ngModelChange)="markDirty('campaignName')" />
			<p *ngIf="errors.campaignName" class="error">{{ errors.campaignName }}</p>
		</div>
		&nbsp;
		<div class="activate">
			<div class="activate-button {{ statusId == 4 ? 'inactive' : 'active' }}" (click)="toggleActive()">
				<ng-container *ngIf="statusId == 4">
					<i class="pi pi-times"></i>
					<span>Deactivated</span>
				</ng-container>
				<ng-container *ngIf="statusId != 4">
					<i class="pi pi-check"></i>
					<span>Activated</span>
				</ng-container>
			</div>
		</div>
	</div>
	<div class="employers">
		<h2>Employer</h2>
		<div class="employer-type">
			<div class="radio"><p-radioButton [(ngModel)]="employerType" value="all" (ngModelChange)="markDirty('employerType')" [disabled]="campaign?.emailTypeID === emailType.Drip"></p-radioButton></div>
			<div class="label">All Employers</div>
			<div class="radio align-top"><p-radioButton [(ngModel)]="employerType" value="selected" (ngModelChange)="markDirty('employerType')" [disabled]="campaign?.emailTypeID === emailType.Drip"></p-radioButton></div>
			<div class="label">
				<div class="button neutral" (click)="selectEmployers()" [class.disabled]="campaign?.emailTypeID === emailType.Drip">Select Employers</div>
				<div class="employer-list">{{ selectedEmployerNames }}</div>
				<div class="drip-restriction" *ngIf="campaign?.emailTypeID === emailType.Drip">
					<small class="text-muted">Drip campaigns must target all employers</small>
				</div>
			</div>
		</div>
	</div>
	<div class="schedule">
		<h2>
			Schedule
			<span class="material-symbols-outlined info-icon" [pTooltip]="'Scheduling for Drip programs is handled on the Drip Program configuration screen'" tooltipPosition="top" [appendTo]="'body'" tooltipStyleClass="tooltip-wrap">info</span>
		</h2>
		<div class="schedule-type">
			<div class="radio"><p-radioButton [(ngModel)]="campaign.emailTypeID" [value]="emailType.Single" (ngModelChange)="markDirty('emailType'); setCampaignType(emailType.Single)"></p-radioButton></div>
			<div class="label">
				<span>One time on: </span><p-calendar [(ngModel)]="campaign.deliveryDateTime" [showTime]="true" [hourFormat]="'12'" (ngModelChange)="markDirty('deliveryDateTime')"></p-calendar>
				<p *ngIf="errors.deliveryDateTime" class="error">{{ errors.deliveryDateTime }}</p>
			</div>
			<div class="radio"><p-radioButton [(ngModel)]="campaign.emailTypeID" [value]="emailType.Drip" (ngModelChange)="markDirty('emailType'); setCampaignType(emailType.Drip)"></p-radioButton></div>
			<div class="label">
				<span>Drip</span>
			</div>
		</div>
	</div>
	<div class="email">
		<h2>Email</h2>

		<div class="email-details">
			<label>Subject</label>
			<div>
				<input pInputText [(ngModel)]="campaign.eMailSubject" (ngModelChange)="markDirty('eMailSubject')" />
				<p *ngIf="errors.eMailSubject" class="error">{{ errors.eMailSubject }}</p>
			</div>
			<label>Template</label>
			<p-dropdown [options]="templates" [(ngModel)]="selectedTemplate" (onChange)="templateSelected($event)" optionLabel="templateName" [autoDisplayFirst]="false"></p-dropdown>
		</div>
	</div>

	<div class="sms">
		<h2>SMS</h2>
		<div class="sms-details">
			<div class="sms-message">
				<label>
					SMS Message
					<span class="material-symbols-outlined info-icon" [pTooltip]="'Text shown before the full-email link in the SMS.'" tooltipPosition="top" [appendTo]="'body'" tooltipStyleClass="tooltip-wrap">info</span>
				</label>
				<div>
					<textarea pInputTextarea [(ngModel)]="campaign.smsMessage" (ngModelChange)="markDirty('smsMessage')" rows="4" placeholder="Enter SMS message content..." [style]="{ width: '100%', resize: 'vertical' }"></textarea>
					<p *ngIf="errors.smsMessage" class="error">{{ errors.smsMessage }}</p>
				</div>
			</div>
		</div>
	</div>

	<div class="template">
		<h2>Email Content</h2>
		<app-substitution-fields [showVimeoOption]="true"></app-substitution-fields>
		<email-editor (loaded)="editorLoaded($event)" [options]="editorOptions" [minHeight]="'1000px'"></email-editor>
	</div>
</div>

<p-dialog [(visible)]="showEmployeeChooser" [modal]="true" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<span class="header">Employee Chooser</span>
	</ng-template>

	<div class="employer-chooser">
		<div class="search">
			<input pInputText type="text" [(ngModel)]="employeeSearchTerm" (input)="filterEmployers()" placeholder="Search Employees" />
		</div>
		<div class="employer-list">
			<ul>
				<li *ngFor="let employee of filteredEmployers">
					<p-checkbox [(ngModel)]="employee.selected" [binary]="true"></p-checkbox>
					{{ employee.employerName }}
				</li>
			</ul>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<div class="actions">
			<div class="button success" (click)="confirm()">Save</div>
			<div class="button neutral" (click)="close()">Cancel</div>
		</div>
	</ng-template>
</p-dialog>

<p-dialog [(visible)]="testFormVisible" [header]="'Test Campaign'" [style]="{ width: '35%' }">
	<p>Test the campaign by sending communications to yourself. Enter your email address and phone number.</p>
	<div class="test-form">
		<div class="field">
			<label>Email Address</label>
			<input pInputText [(ngModel)]="testEmail" />
		</div>
		<div class="field">
			<label>Phone Number</label>
			<input pInputText [(ngModel)]="testPhone" />
		</div>
		<div class="field">
			<label>Test as this Employer</label>
			<p-dropdown [options]="allEmployers" [(ngModel)]="testEmployer" [optionLabel]="'employerName'" [autoDisplayFirst]="false" [appendTo]="'body'"></p-dropdown>
		</div>
	</div>
	<footer class="test-footer">
		<div class="button success" (click)="sendTest()">Send Test</div>
		<div class="button neutral" (click)="testFormVisible = false">Cancel</div>
	</footer>
</p-dialog>
